import { useMemo } from 'react';
import { FormField } from '@src/components/SmartDataTable/types';
import { CATEGORY_OPTIONS } from '../../constants';
import { cleanPhoneNumber } from '@src/utils/phoneUtils';

export const useInsideStockItemsFormFields = (): ((
  record?: any
) => FormField[]) => {
  // Memoized optionRender functions to prevent infinite re-renders
  const supplierOptionRender = useMemo(
    () => (item: any) => (item ? `${item.name} (${item.phone})` : ''),
    []
  );

  const supplierOptionLabel = useMemo(
    () => (item: any) => (item ? `${item.name} (${item.phone})` : ''),
    []
  );

  return useMemo(
    () => (record?: any) =>
      [
        // Row 1: Name, Category
        {
          name: 'name',
          label: 'Item Name',
          type: 'text',
          required: true,
          placeholder: 'Enter item name...',
          layout: { span: 12 },
        },
        {
          name: 'category',
          label: 'Category',
          type: 'select',
          required: true,
          options: CATEGORY_OPTIONS,
          placeholder: 'Select category...',
          layout: { span: 12 },
        },

        // Row 2: Unit, Current Stock
        {
          name: 'unit',
          label: 'Unit',
          type: 'text',
          required: true,
          placeholder: 'Enter unit...',
          layout: { span: 12 },
        },

        // Row 3: Min Stock, Max Stock
        {
          name: 'min_stock',
          label: 'Minimum Stock',
          type: 'number',
          required: true,
          defaultValue: 1,
          placeholder: '0',
          min: 0,
          step: 1,
          layout: { span: 12 },
        },
        {
          name: 'max_stock',
          label: 'Maximum Stock',
          type: 'number',
          required: true,
          defaultValue: 10,
          placeholder: '10',
          min: 0,
          step: 1,
          layout: { span: 12 },
        },

        // Row 4: Supplier ID
        {
          name: 'supplier_id',
          label: 'Supplier',
          type: 'resourceSelect',
          required: false,
          placeholder: 'Search and select supplier...',
          searchSelectProps: {
            resource: 'inside-inventory-suppliers',
            optionValue: 'id',
            optionLabel: supplierOptionLabel,
            searchFields: ['name', 'phone'],
            optionRender: supplierOptionRender,
            allowClear: true,
          },
          layout: { span: 12 },
          defaultValue: null,
          onChange: (value: any, form: any) => {
            // Convert empty string to null for database
            if (value === '') {
              form.setFieldsValue({ referred_by_name: null });
            }
          },
          props: {
            validateTrigger: ['onBlur', 'onChange'],
            validateOnMount: false,
            validateFirst: false,
          },
        },
      ] as FormField[],
    []
  );
};
